import * as React from 'react'
import { BaseOverviewHeaderItemProps } from '../../../pages/BaseOverview/BaseOverview'
import MoneyText from '../../../components/Text/Currency/MoneyText'
import {
    BaseFixedPriceOverviewProps,
    ExtendedFixedPriceOverviewDto,
    FixedPriceFilterType,
    FixedPriceOverviewCount,
    FixedPriceSortingType,
    useItemStyles,
} from './BaseFixedPriceOverview'
import useCurrencies from '../../../hooks/useCurrencies'
import { Checkbox, Tooltip } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'
import BaseOverviewCountBadge from '../../../pages/BaseOverview/BaseOverviewCountBadge'

export default function FixedPriceHeaderItem(
    props: BaseOverviewHeaderItemProps<ExtendedFixedPriceOverviewDto, FixedPriceFilterType, FixedPriceSortingType, FixedPriceOverviewCount>,
) {
    const fixedPriceProps = props as unknown as BaseFixedPriceOverviewProps
    const fixedPriceStyles = useItemStyles()
    const { t: translate } = useTranslation()
    const { getCurrency } = useCurrencies()

    if (props.viewportNarrow) {
        return (
            <>
                {props.onAllItemsSelected ? (
                    <>
                        <Checkbox
                            checked={props.isAllItemsSelected?.(props.items)}
                            disabled={!props.isAllItemsSelectable?.(props.items)}
                            onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                        />
                        <div></div>
                        <div></div>
                    </>
                ) : (
                    <BaseOverviewCountBadge {...props} />
                )}
                <div></div>
                <div></div>
                <div
                    className={
                        props.viewportTiny ? fixedPriceStyles.listFixedPriceItemTinyBottomRow : fixedPriceStyles.listFixedPriceItemSmallBottomRow
                    }
                >
                    <div></div>
                    <Tooltip relationship={'label'} content={translate('registration.rate')} withArrow>
                        <div>
                            {props.count.currencies?.map((currency, index) => (
                                <MoneyText key={index} amount={currency.turnover} currency={getCurrency(currency.currency)} align="right" />
                            ))}
                        </div>
                    </Tooltip>
                    {!props.viewportTiny && !fixedPriceProps.hideInvoiceField && (
                        <Tooltip relationship={'label'} content={translate('registration.turnover')} withArrow>
                            <div>
                                {props.count.currencies?.map((currency, index) => (
                                    <MoneyText
                                        key={index}
                                        amount={currency.invoiceTurnover}
                                        currency={getCurrency(currency.currency)}
                                        align="right"
                                    />
                                ))}
                            </div>
                        </Tooltip>
                    )}
                </div>
            </>
        )
    }

    return (
        <>
            {props.onAllItemsSelected ? (
                <>
                    <Checkbox
                        checked={props.isAllItemsSelected?.(props.items)}
                        disabled={!props.isAllItemsSelectable?.(props.items)}
                        onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                    />
                    <div></div>
                </>
            ) : (
                <BaseOverviewCountBadge {...props} />
            )}
            <div></div>
            <div></div>
            <Tooltip relationship={'label'} content={translate('registration.rate')} withArrow>
                <div>
                    {props.count.currencies?.map((currency, index) => (
                        <MoneyText key={index} amount={currency.turnover} currency={getCurrency(currency.currency)} align="right" />
                    ))}
                </div>
            </Tooltip>
            {!fixedPriceProps.hideInvoiceField && (
                <Tooltip relationship={'label'} content={translate('registration.turnover')} withArrow>
                    <div>
                        {props.count.currencies?.map((currency, index) => (
                            <MoneyText key={index} amount={currency.invoiceTurnover} currency={getCurrency(currency.currency)} align="right" />
                        ))}
                    </div>
                </Tooltip>
            )}
        </>
    )
}
